import { useDispatch, useSelector } from "react-redux";
import { getItems } from "../../actions/itemActions";
import { useEffect } from "react";
import ProductCard from "./ProductCard/ProductCard";
import CategoryCard from "./CategoryCard/CategoryCard";
import { Row, Col, Container } from "react-bootstrap";

const category = [
  { id: 1, category: "PRT Shocks" },
  { id: 2, category: "Brakes, Suspension & Steering" },
  { id: 3, category: "Batteries and Chargers" },
  { id: 4, category: "Sensors" },
  { id: 5, category: "Engine & Drivetrain" },
  { id: 6, category: "Filters" },
  { id: 7, category: "Auto Body Parts & Mirrors" },
];

const ProductBanner = () => {
  const { items = [] } = useSelector((state) => state.itemReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getItems("api/product/"));
  }, [dispatch]);

  return (
    <Container fluid className="p-0 mt-4">
      {/* New Products */}
      <section>
        <h2 className="px-3 py-2 m-0 text-white" style={{ background: "#2333c7" }}>
          New Products
        </h2>

        {/* xs: no gaps (g-0) => full-bleed; sm+: controlled gutters */}
        <Row className="g-0 g-sm-2 g-md-3 px-2 px-sm-3 py-3">
          {items.slice(0, 6).map((item) => (
            <Col
              key={item.id}
              xs={6}
              sm={6}
              md={4}
              lg={3}
              xl={2}
              className="d-flex"
            >
              <ProductCard item={item} />
            </Col>
          ))}
        </Row>
      </section>

      {/* Categories */}
      <section className="mt-4">
        <h2 className="px-3 py-2 m-0 text-white" style={{ background: "#2333c7" }}>
          Shop By Category
        </h2>

        <Row className="g-0 g-sm-2 g-md-3 px-2 px-sm-3 py-3">
          {category.map((cat) => (
            <Col
              key={cat.id}
              xs={6}
              sm={6}
              md={4}
              lg={3}
              xl={2}
              className="d-flex"
            >
              <CategoryCard category={cat.category} link={cat.id} />
            </Col>
          ))}
        </Row>
      </section>
    </Container>
  );
};

export default ProductBanner;
